@use "ui/styles/sizes";

.wrapper {
  display: flex;
  align-items: center;
  gap: sizes.$s4;
}

.dateField {
  display: flex;
  align-items: baseline;
  gap: sizes.$s2;

  input[type="date"] {
    min-width: 9rem;
    text-align: center;
    padding-inline: sizes.$s2;
    justify-content: center;
    font-family: monospace;
  }
}

.dateLabel {
  font-size: 13px;
  color: var(--secondary-text-color);
  white-space: nowrap;
}

.presetSelect {
  width: 160px;
}

// Firefox's native date input internals need more vertical space than
// the fixed height allows (8px content area with 9px padding + 1px border).
// Explicitly control height and padding per size on Firefox.
@supports (-moz-appearance: none) {
  .medium input[type="date"] {
    height: 24px;
    padding-block: 2px;
  }

  .mediumLarge input[type="date"] {
    height: 28px;
    padding-block: 4px;
  }

  .large input[type="date"] {
    height: 41px;
    padding-block: 6px;
  }
}
